import { render } from "./mainBody.vue?vue&type=template&id=5c572284"
import script from "./mainBody.vue?vue&type=script&lang=js"
export * from "./mainBody.vue?vue&type=script&lang=js"

import "./mainBody.vue?vue&type=style&index=0&id=5c572284&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__